<div class="cpu-usage">
  <h2>Group CPU Usage</h2>

  <app-segmented-radio
    name="usage-period"
    idPrefix="usage-period"
    [options]="periods"
    [(value)]="selectedPeriod"
    id="s-radio"
  />

  <div class="chart-container">
    <canvas
      baseChart
      [data]="lineChartData"
      [options]="lineChartOptions"
      [type]="lineChartType"
    ></canvas>
  </div>
</div>
